module.exports = "/_next/static/images/17f72e0a9d9a510e83ada5fab4616b10-ana_1@3x.png.webp";